import {
  IconBulb,
  IconFlag,
  IconKeyFilled,
  IconMessage2,
  IconUserFilled,
} from '@rossum/ui/icons/tabler';
import Header from '../../../components/Sidebar/Header';
import SidebarWrapper from '../../../components/Sidebar/Sidebar';
import SidebarNavLink from '../../../components/Sidebar/SidebarNavLink';
import { DEV_FEATURES_ENABLED } from '../../../constants/config';

const Sidebar = () => (
  <SidebarWrapper>
    <Header title="containers.personalInfo.title" />
    <SidebarNavLink
      icon={<IconUserFilled />}
      text="containers.personalInfo.personalInformation"
      to="/account/personalInfo"
      replace
      dataCy="my-profile-personal-settings"
    />
    <SidebarNavLink
      icon={<IconKeyFilled />}
      text="containers.personalInfo.changePassword"
      to="/account/changePassword"
      replace
      dataCy="my-profile-change-password"
    />
    {DEV_FEATURES_ENABLED && (
      <>
        <SidebarNavLink
          icon={<IconBulb />}
          text="containers.personalInfo.rossumLabs"
          to="/account/rossumLabs"
          replace
          dataCy="my-profile-lab-features"
        />
        <SidebarNavLink
          icon={<IconFlag />}
          text="containers.personalInfo.changeFeatureFlags"
          to="/account/changeFeatureFlags"
          replace
          dataCy="my-profile-change-feature-flags"
        />
        <SidebarNavLink
          icon={<IconMessage2 />}
          text="containers.personalInfo.discoveryCallSurveys"
          to="/account/discoveryCallSurveys"
          replace
          dataCy="my-profile-discovery-calls"
        />
      </>
    )}
  </SidebarWrapper>
);

export default Sidebar;
